import { Container, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRoutes } from "../../router/routes";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F5F7FA",
    height:"100vh"
  },
  check: {
    fontSize: "75px",
    color: theme.palette.success.main,
  },
  msg: {
    fontWeight: "bold",
    fontSize: "0.78125",
    marginTop: "8px",
  },
}));

export const Payment = ({ failure = false , t = () => false }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    setTimeout(() => {
      navigate(AppRoutes?.home);
    }, 4000)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      maxWidth="sm"
      className={classes.root}
    >
      <div>
        <img
          src={location?.state ? "https://i.pinimg.com/originals/a1/05/7d/a1057dcb644d8729f4f76b2032f21743.gif" : "/images/failed.gif"}
          alt=""
          style={{ height: "50%", width: "100px", borderRadius: "60%" }}
        />
        <Typography variant="body1" textAlign="center" className={classes.msg} noWrap>
          {!location?.state ? t("Reconciliation") : t("Reconciliation")}
        </Typography>
        <Typography variant="body1" textAlign="center" className={classes.msg} noWrap>
          {!location?.state ? t("request failed") : t("request submitted successfully")}
        </Typography>
      </div>
    </Container>
  );
};
